import React from 'react';
import '../Colors.css';

const BusStop = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslGreyDark' d="M56.882-0.007c31.422 0 56.89 25.468 56.89 56.89v967.128h-113.779v-967.128c0-31.422 25.468-56.89 56.89-56.89z"/>
      <path className='Bus' d="M199.107 199.107h142.224v85.335h-142.224v-85.335z"/>
      <path className='Bus' d="M199.107 312.886h654.231v28.445h-654.231v-28.445z"/>
      <path className='Bus' d="M369.776 199.107h142.224v85.335h-142.224v-85.335z"/>
      <path className='Bus' d="M540.445 199.107h142.224v85.335h-142.224v-85.335z"/>
      <path className='Bus' d="M967.118 56.882h-910.235v512.007h910.235c31.422 0 56.89-25.468 56.89-56.89v-398.228c0-31.422-25.468-56.89-56.89-56.89zM881.783 398.221c0 15.711-12.734 28.445-28.445 28.445h-59.371c1.579 4.454 2.482 9.226 2.482 14.222 0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667c0-4.996 0.903-9.768 2.482-14.222h-374.747c1.579 4.454 2.482 9.226 2.482 14.222 0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667c0-4.996 0.903-9.768 2.482-14.222h-59.371c-15.711 0-28.445-12.734-28.445-28.445v-199.114c0-15.711 12.734-28.445 28.445-28.445h654.231c15.711 0 28.445 12.734 28.445 28.445v199.114z"/>
      <path className='Bus' d="M711.114 199.107h142.224v85.335h-142.224v-85.335z"/>
    </svg>
  );
};

export default BusStop;